import {useFlags} from 'launchdarkly-react-client-sdk';
import React from 'react';
import {styled, Box} from '@mui/material';
import {Body} from '@lightricks/react-design-system';
import WebPaymentsLoginRedirect from '@/routes/auth/WebPaymentsLoginRedirect';
import translate from '@/utils/translate';
import LEGACY_COLORS from '@/config/legacyColors';
import {ROUTES} from '@/config/routesConstants';
import Link from '@/components/link';
import BaseAuth from '../BaseAuth';

const BrandsFooterContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  marginTop: '50px',
}));

const BrandsFooterTextContainer = styled(Box)(() => ({
  display: 'inline',
}));

function BrandsFooter() {
  return (
    <BrandsFooterContainer>
      <BrandsFooterTextContainer>
        <Body
          size="sm"
          color={LEGACY_COLORS.GRAY}
          sx={{whiteSpace: 'pre-wrap', textAlign: 'center'}}
        >
          {translate(
            "Don't have an account, but you're ready to Create Something Worth Sharing?"
          )}{' '}
          <Link
            to="https://popularpays.com/survey-demo/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: LEGACY_COLORS.GRAY_MEDIUM_DARK,
              textDecoration: 'underline',
            }}
          >
            {translate('Request a demo')}
          </Link>{' '}
          {translate(
            'of Popular Pays at Lightricks Agile Advertising Platform.'
          )}
        </Body>
      </BrandsFooterTextContainer>
      <BrandsFooterTextContainer>
        <Body
          size="sm"
          color={LEGACY_COLORS.GRAY}
          sx={{whiteSpace: 'pre-wrap', textAlign: 'center'}}
        >
          {translate('Need some help logging in?')}{' '}
          <Link
            to="https://help-popularpays.lightricks.com/hc/en-us/requests/new"
            target="_blank"
            rel="noopener noreferrer"
            style={{color: LEGACY_COLORS.BLUE, textDecoration: 'underline'}}
          >
            {translate('Contact us')}
          </Link>
        </Body>
      </BrandsFooterTextContainer>
    </BrandsFooterContainer>
  );
}

export default function BrandsLogin() {
  const {
    googleAuthentication,
    appleAuthentication,
    facebookAuthentication,
    enableWebPaymentsLoginPage,
  } = useFlags();

  const title = translate('Log in to Popular Pays');
  const subtitle = translate('Work with top creators to amplify your brand');
  if (enableWebPaymentsLoginPage) {
    return <WebPaymentsLoginRedirect />;
  }

  return (
    <BaseAuth
      mode="login"
      product="campaign-management"
      title={title}
      subtitle={subtitle}
      redirectTo={ROUTES.HOME}
      onlyEmail
      emailLabelKey="email"
      oauthOptions={{
        google: !!googleAuthentication,
        apple: !!appleAuthentication,
        facebook: !!facebookAuthentication,
      }}
      requireTermsAgreement={false}
      submitButtonTextKey="Login with email"
      footer={<BrandsFooter />}
    />
  );
}
